import { AlertContainer } from "src/components/Alert"
import { OpenWebsiteNewTabDialog } from "src/components/OpenWebsiteNewTabDialog"

export function WebOnlyOverlays() {
  return (
    <>
      <AlertContainer />
      <OpenWebsiteNewTabDialog />
    </>
  )
}
